import React from 'react';
const { useState, useEffect, useMemo, useCallback, useRef } = React;

export { useState, useEffect, useMemo, useCallback, useRef };

// =============================================
// GOOGLE AUTH & DRIVE SYNC
// =============================================
export const GOOGLE_CLIENT_ID = '850520978553-8ffcedh2o7fndagk78fhk2bssq3h7pjq.apps.googleusercontent.com';
export const ALLOWED_EMAIL = 'dwanninayaka@gmail.com';
export const DRIVE_FILE_NAME = 'iplanner-data-sync.json';
export const FI_REPORT_FILE_NAME = 'iplanner-fi-report.json';   // Fixed name — always overwritten
export const ADVISOR_REPORT_FILE_NAME = 'iplanner-fi-report-advisor.json'; // Advisor version — always overwritten
// Visible path in the user's Google Drive: My Drive / Application / iPlanner / iplanner-data-sync.json
export const DRIVE_FOLDER_PATH = ['Application', 'iPlanner'];
// Hardcoded ID of the pre-existing 'Application' folder — eliminates all search
// calls for that folder and allows drive.file scope (non-sensitive, no warning).
export const APPLICATION_FOLDER_ID = '1t-cAJoXFhsHKabug3gCwt3-GzQkbt1FY';
// drive.file is non-sensitive — no "unverified app" warning shown to users.
// Works because Application folder ID is hardcoded; we only search/create
// the iPlanner sub-folder which this app itself owns.
export const DRIVE_SCOPE = 'https://www.googleapis.com/auth/drive.file';

// localStorage keys for persisting resolved IDs across sessions
export const LS_FOLDER_ID = 'iPlanner_driveFolderId';   // resolved iPlanner leaf folder ID
export const LS_FILE_ID = 'iPlanner_driveFileId';     // resolved sync file ID
export const LS_FI_FILE_ID = 'iPlanner_driveFIFileId'; // resolved FI report file ID
export const LS_ADVISOR_FILE_ID = 'iPlanner_driveAdvisorFileId'; // resolved Advisor report file ID

// Initial data
// =============================================
// DEFAULT DATA (empty — real data lives in localStorage or data.json)
// To pre-populate the app with your data:
//   1. Place a 'data.json' file alongside this app.html
//   2. On first load (no localStorage), the app will import it
//   3. data.json is .gitignored and never pushed to GitHub
// =============================================

export const initialGoldInventory = [];
export const initialPersonalLoans = [];
export const initialGoldLoans = [];
export const initialAccounts = [];
export const initialCreditCards = [];

// Initial Budget Data
export const initialSGBudgetCycle1 = [];
export const initialSGBudgetCycle2 = [];
export const initialLKBudgetDamith = [];
export const initialLKBudgetShan = [];

// =============================================
// SUB-MODULE CONFIG — 5-tab grouped navigation
// =============================================
// Nav groups:
//   Home    → dashboard          (no sub-tabs)
//   Wealth  → assets + investments + fixed-assets (sub-tabs)
//   Debt    → liabilities        (sub-tabs)
//   Budget  → budget             (sub-tabs)
//   More    → drawer: settings, fi-advisor

// Section nav group mapping — tells us which bottom-nav tab is "active"
export const SECTION_NAV_GROUP = {
    dashboard: 'home',
    assets: 'wealth',
    investments: 'wealth',
    'fixed-assets': 'wealth',
    liabilities: 'debt',
    budget: 'budget',
    settings: 'more',
    'fi-advisor': 'more',
    milestones: 'more',
};

export const SECTION_TITLES = {
    dashboard: 'Dashboard',
    assets: 'Wealth',
    liabilities: 'Debt',
    investments: 'Wealth',
    'fixed-assets': 'Wealth',
    budget: 'Budget',
    settings: 'Settings',
    'fi-advisor': 'FI Advisor',
    milestones: 'Journey',
};

// Wealth group merges assets, investments, fixed-assets into one sub-tab row
export const SUB_MODULES = {
    // All three wealth sections share the SAME sub-tab list
    assets: [
        { id: 'accounts', label: 'Accounts', section: 'assets' },
        { id: 'gold', label: 'Gold', section: 'assets' },
        { id: 'inv-portfolio', label: 'Invest', section: 'investments' },
        { id: 'fa-overview', label: 'Property', section: 'fixed-assets' },
    ],
    investments: [
        { id: 'accounts', label: 'Accounts', section: 'assets' },
        { id: 'gold', label: 'Gold', section: 'assets' },
        { id: 'inv-portfolio', label: 'Invest', section: 'investments' },
        { id: 'fa-overview', label: 'Property', section: 'fixed-assets' },
    ],
    'fixed-assets': [
        { id: 'accounts', label: 'Accounts', section: 'assets' },
        { id: 'gold', label: 'Gold', section: 'assets' },
        { id: 'inv-portfolio', label: 'Invest', section: 'investments' },
        { id: 'fa-overview', label: 'Property', section: 'fixed-assets' },
    ],
    liabilities: [
        { id: 'personal', label: 'Loans', section: 'liabilities' },
        { id: 'gold-loans', label: 'Pawning', section: 'liabilities' },
        { id: 'cards', label: 'Cards', section: 'liabilities' },
    ],
    budget: [
        { id: 'budget-dashboard', label: 'Overview', section: 'budget' },
        { id: 'budget-income', label: '💰 Income', section: 'budget' },
        { id: 'sg-budget', label: '🇸🇬 SG', section: 'budget' },
        { id: 'lk-budget', label: '🇱🇰 LK', section: 'budget' },
        { id: 'budget-history', label: '📁 History', section: 'budget' },
    ],
};

// Nav color per group
export const NAV_GROUP_COLORS = {
    home: '#FFD700',
    wealth: '#10B981',
    debt: '#EF4444',
    budget: '#60A5FA',
    more: '#A78BFA',
};

// Sub-tab active class per nav group
export const NAV_GROUP_TAB_CLASS = {
    wealth: 'wealth-active',
    debt: 'debt-active',
    budget: 'budget-active',
};
